<template>
	<div
		style="width: 95%"
		class="ml-5 mt-4"
	>
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<b-modal
			id="crossSell-modal"
			ref="addcrossSell-modal"
			hide-footer
		>
			<template #modal-title>
				Create New Cross Sell
			</template>
			<div class="d-block text-center">
				<b-form-group
					class="form-group"
					label="Name: "
					label-for="block-form1-name"
				>
					<Field
						v-slot="{ errors }"
						v-model="name"
						rules="required"
						name="name"
					>
						<div
							class="control"
						>
							<b-form-input
								v-model="name"
								type="text"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
				<b-form-group
					label="Cross Sell ID:"
					label-for="example-select"
				>
					<b-input-group>
						<custom-select
							id="example-select"
							v-model="crosssellid"
							plain
						>
							<b-form-select-option :value="undefined">
								Please select an Option
							</b-form-select-option>
							<b-form-select-option
								v-for="(off,id) in offerings"
								:key="id"
								:value="off.id"
							>
								{{ off.id }} | {{ off.size }} - {{ off.description }}
							</b-form-select-option>
						</custom-select>
					</b-input-group>
				</b-form-group>
			</div>
			<b-button
				class="mt-3"
				block
				@click="addCrossSell()"
			>
				Save
			</b-button>
		</b-modal>
		<b-row class="d-flex justify-content-end mb-4">
			<b-col
				sm="5"
				md="3"
				class="my-1"
				align-self="center"
			>
				<b-form-group
					label="Language:"
					label-for="search-group-select"
					label-cols-sm="6"
					label-cols-md="4"
					label-cols-lg="4"
					label-align-sm="right"
					label-size="sm"
					class="mb-0"
				>
					<custom-select
						id="search-group-select"
						v-model="language"
						size="sm"
						:options="languageOptions"
						@change="translateTableData(language)"
					/>
				</b-form-group>
			</b-col>
		</b-row>
		<base-block
			title="Existing Cross Sell"
			header-bg
		>
			<div
				ref="crossSellTable"
			/>
		</base-block>
	</div>
</template>

<style lang="scss">
@import "../../assets/scss/custom/errors";
</style>
